<template>
    <Head title="Create Award"/>
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl leading-tight">
                Create Award
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form enctype="multipart/form-data"
                      @submit.prevent="create.post(requestUrl, { preserveScroll: true})"
                      class="w-full">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Name</admin-app-label>
                            <input-basic
                                placeholder="Name"
                                v-model="create.name"
                                :error="errors['name']"
                            />
                            <input-error v-if="errors['name']">
                                {{ errors.name }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4 relative">
                            <admin-app-label>Group</admin-app-label>
                            <a class="block tracking-wider uppercase cursor-pointer mt-2 absolute -top-4 right-0" href="/admin/award-groups/create">
                                <font-awesome-icon icon="plus" class="mr-3"/>
                                Add New Group
                            </a>
                            <input-select
                                placeholder="Group"
                                labelKey="Group"
                                label="name"
                                :options="groups"
                                v-model="create.group_id"
                                :error="errors['group_id']"
                                :reduce="groups => groups.id"
                            />
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Excerpt</admin-app-label>
                        <input-textarea
                            class="min-h-[200px]"
                            placeholder="Excerpt"
                            v-model="create.excerpt"
                            :error="errors['excerpt']"
                        />
                        <input-error v-if="errors['excerpt']">
                            {{ errors.excerpt }}
                        </input-error>
                        <p class="text-sm text-placeholder mt-1">
                            Add a small excerpt that will serve as a short description of this award.
                            This excerpt will be used on the awards page next to the winner.
                        </p>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Order</admin-app-label>
                            <input-basic
                                type="number"
                                placeholder="Order"
                                v-model="create.order"
                                min="0"
                                :error="errors['order']"
                            />
                            <p class="text-sm text-placeholder mt-1">
                                This sets the order of the award in it's group. 0 being first.
                            </p>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Image</admin-app-label>
                            <image-upload
                                :key="`Image`"
                                :label="`Image`"
                                v-model="create.image"
                                :error="errors['image']"
                            />
                        </div>
                    </div>
                    <div class="grid grid-cols-2 md:grid-cols-2 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Assign Award To Product</admin-app-label>
                            <input-select
                                placeholder="Product"
                                labelKey="Product"
                                v-model="create.product_id"
                                :options="products"
                                :error="errors['product_id']"
                                :get-option-label="getLabel"
                                label="name"
                                class="no-overflow"
                                :reduce="product => product.id"
                            />
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Award Order</admin-app-label>
                            <input-basic
                                type="number"
                                placeholder="Award Order"
                                v-model="create.award_order"
                             />
                            <p class="text-sm text-placeholder mt-1">
                                Set the sort order for this award. Awards with 0 & 1 will appear on the tyre page.
                            </p>
                        </div>
                    </div>
                    <app-button type="submit" :disabled="create.processing" class="mt-8">Create</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import AppButton from "@/Components/AppButton";
import AddVideos from "@/Components/Admin/Forms/AddVideos";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated.vue";
import {Head, useForm} from "@inertiajs/inertia-vue3";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputTextarea from "@/Components/Admin/Forms/Inputs/InputTextarea";
import ImageUpload from "@/Components/Admin/Forms/Inputs/ImageUpload";
import InputError from "@/Components/Forms/Inputs/InputError";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";

export default {
    name: "Create",
    components: {
        AppButton,
        AddVideos,
        AdminAppLabel,
        BreezeAuthenticatedLayout,
        BreadCrumbs,
        FontAwesomeIcon,
        InputBasic,
        InputError,
        InputSelect,
        InputTextarea,
        ImageUpload,
        Head,
    },
    props: {
        years: Object,
        seasons: Object,
        groups: Object,
        products: Object,
        errors: Object,
        classifications: Object,
        requestUrl: {
            type: String,
            default: "/admin/awards"
        }
    },
    methods:
    {
        getLabel: function(val)
        {
            if(typeof  val === 'object')
            {
                return val.name + ' | ' + val.identifier
            }
        },
    },
    data() {
        return {
            navItems: [
                {title: "Awards", path: "/admin/awards"},
                {title: "Create New", path: "/admin/awards/create"},
            ],
            create: useForm(
                {
                    name: "",
                    image: null,
                    order: "",
                    excerpt: "",
                    group_id: "",
                    product_id: "",
                    award_order: ""
                }
            )
        };
    }
}
</script>

<style scoped>
</style>
